var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useJobStore } from './jobStore';
/**
 * Waits for a server-sent event job to complete.
 * Manages the SSE connection lifecycle via the central jobStore.
 *
 * @param url The SSE endpoint URL for the job.
 * @param toastTitle Optional title for a loading toast notification.
 * @returns A promise that resolves when the job is 'completed', or rejects on 'error' or 'timeout'.
 */
export const waitForJob = (url, toastTitle) => __awaiter(void 0, void 0, void 0, function* () {
    // Directly call the store's subscribe method
    // The store now handles connection creation/reuse, timeouts, toasts, and promise resolution/rejection.
    return useJobStore.getState().subscribeToJob(url, toastTitle);
});
//# sourceMappingURL=waitForJob.js.map